import { useQuery } from '@tanstack/react-query';
import { getAllLocations } from '../../services/location';
import { QueryKey } from '../../enums/QueryKey';

export function useHEMTLocations() {
    const { data } = useQuery({
        queryKey: [QueryKey.AllLocationsFromHEMT],
        queryFn: getAllLocations,
        initialData: [],
    });

    return data;
}
